import React from "react";

import { Route } from "react-router-dom";

const LazySecretsListPage = React.lazy(
  () => import("./components/SecretsList")
);

export const routes = (
  <>
    <Route index element={<LazySecretsListPage />} />
  </>
);
